import Vue from 'vue';
import store from './../../store';

const success = (data, resolve) => {
  const subscriberList = [];
  data.forEach((item) => {
    subscriberList.push({ id: item.id, name: item.name });
  });
  store.dispatch('fetchAllSubscriberList', subscriberList);
  resolve();
};

const failed = (errors, reject) => reject(errors);

export default () => (
  new Promise((resolve, reject) => {
    Vue.$http
      .get('subscriberList')
      .then((response) => {
        success(response.data.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/subscriberList/all.js